export enum SystemSetting {
  ALLOW_ONLINE_APPROVALS = "AllowOnlineApprovals",
  ENCRYPT_PASSWORDS = "EncryptPasswords",
  SEND_REQUEST_FOR_APPROVAL_ON_DRAW_COMPLETED = "SendRequestForApprovalOnDrawCompleted",
  NEW_DRAW_REQUEST_COLOR = "NewDrawRequestColor",
  NEW_DRAW_AVAILABLE_COLOR = "NewDrawAvailableColor",
  NEW_INSPECTION_REQUEST_COLOR = "NewInspectionRequestColor",
  PROJECT_LOCKED_COLOR = "ProjectLockedColor",
  TBD_PROJECT_COLOR = "TBDProjectColor",
  NEW_FILES_AVAILABLE_COLOR = "NewFilesAvailableColor",
  PROJECT_IMPORTED_COLOR = "ProjectImportedColor",
  PROJECT_DECLINED_COLOR = "ProjectDeclinedColor",
  DRAW_FILE_STORAGE_TYPE = "DrawFileStorageType",
  DRAW_FILE_PATH = "DrawFilePath",
  DEFAULT_FLEX_ROW_TEMPLATE = "DefaultFlexRowTemplate",
  DISABLED_REPORTS = "DisabledReports",
  DRAW_APPROVED_COLOR = "DrawApprovedColor",
  DEFAULT_IMPORT_GROUP = "DefaultImportGroup",
  DEFAULT_BUDGET_COLUMN_TEMPLATE = "DefaultBudgetColumnTemplate",
}

export enum SettingScope {
  GLOBAL,
  USER,
  FLEX_ROW_TEMPLATES,
  PROJECT,
  GROUP,
  BUDGET_COLUMN_TEMPLATES,
  SUBDIVISION_COLUMN_TEMPLATES,
}
